import { DEFAULT_WIDGET_COLOR } from "@/constants/branding";
import { Operator } from "@/redux/slices/operator/types";
import { RawOperator } from "../operator/types";

export const transformOperator = (operator: RawOperator) => {
  const {
    provider_uuid,
    provider_key,
    domain,
    domain_driver,
    country,
    currency,
    bookable_country_list,
    available_account_types_on_register,
    email,
    joined,
    images,
    name,
    phone,
    primary,
    urls: { brochure, contact_us, privacy_policy, terms },
    branding: { primary_color, secondary_color, tertiary_color, widget_color },
    deep_links,
    flags: { is_simple_signup_enabled, is_suspended },
    kinde_issuer_url,
    kinde_web_client_id,
  } = operator;

  const { logo, emblem, qr, qr_transparent } = images;

  return {
    // Only when the payload actually carries it. Emitting `addOns` unconditionally would turn an ABSENT
    // field into `flightTracking: false` and switch a paid feature off; leaving the key out keeps
    // "not stated" distinguishable from "off" for every consumer.
    ...(operator.add_ons && {
      addOns: {
        flightTracking: Boolean(operator.add_ons.flight_tracking),
        preferredDriver: Boolean(operator.add_ons.preferred_driver),
        worldwideAddressSearch: Boolean(operator.add_ons.worldwide_address_search),
      },
    }),
    id: provider_uuid,
    providerCode: provider_key.toLowerCase(),
    singleTenant: provider_key.toLowerCase() !== "rideminder",
    domain: domain.toLowerCase(),
    domainDriver: domain_driver.toLowerCase(),
    name,
    email,
    joined,
    urls: {
      brochure,
      privacy: privacy_policy,
      terms,
      contact: contact_us,
    },
    images: {
      logo,
      emblem,
      qr,
      qrTransparent: qr_transparent,
    },
    phone,
    primary,
    country,
    currency,
    bookableCountryList: bookable_country_list,
    availableAccountTypesOnRegister: available_account_types_on_register,
    branding: {
      primary: primary_color,
      dark: secondary_color,
      light: tertiary_color,
      widget: widget_color ?? DEFAULT_WIDGET_COLOR,
    },
    registerLinks: {
      driver: deep_links?.driver_registration ?? "",
      client: deep_links?.client_registration ?? "",
    },
    kindeIssuerUrl: kinde_issuer_url,
    kindeClientId: kinde_web_client_id ?? undefined,
    flags: {
      isSimpleSignupEnabled: is_simple_signup_enabled,
      isSuspended: is_suspended,
    },
  } as Operator;
};
